module.exports = __webpack_public_path__ + "img/ronghao_portfolio1.e260cda3.jpg";